import React, { ChangeEvent, useEffect, useState } from 'react';

import { AvatarEditorModal } from '@widgets/cabinet/volunteer/modals/AvatarEditorModal';
import { Avatar } from './Avatar';

interface AvatarInputProps {
  value?: string | null;

  onChange: (avatar: Blob | null) => void;
}

const useAvatar = (defaultAvatarUrl: string | null = null) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(defaultAvatarUrl);

  const [uploadedAvatar, setUploadedAvatar] = useState<File | null>(null);
  const [croppedAvatar, setCroppedAvatar] = useState<Blob | null>(null);

  useEffect(() => {
    if (croppedAvatar) {
      setAvatarUrl(URL.createObjectURL(croppedAvatar));
    }

    return () => {
      if (!avatarUrl) {
        return;
      }

      URL.revokeObjectURL(avatarUrl);
    };
  }, [croppedAvatar]);

  return {
    uploadedAvatar,
    setUploadedAvatar,
    croppedAvatar,
    setCroppedAvatar,
    avatarUrl,
  };
};

export const AvatarInput: React.FC<AvatarInputProps> = (props: AvatarInputProps) => {
  const { uploadedAvatar, setUploadedAvatar, avatarUrl, croppedAvatar, setCroppedAvatar } = useAvatar(props.value);

  const onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setUploadedAvatar(event.target.files[0]);
    }
  };

  useEffect(() => {
    props.onChange(croppedAvatar);
  }, [croppedAvatar]);

  return (
    <>
      <div className="flex flex-col items-center">
        <label>
          <input id="avatar" className="hidden" type="file" onChange={onFileChange} accept="image/*" />

          <Avatar url={avatarUrl} />
        </label>
      </div>

      <AvatarEditorModal
        avatar={uploadedAvatar}
        isVisible={!!uploadedAvatar}
        onClose={() => setUploadedAvatar(null)}
        onEdit={setCroppedAvatar}
      />
    </>
  );
};
